import { render, staticRenderFns } from "./footerText.vue?vue&type=template&id=2371391a&scoped=true"
import script from "./footerText.vue?vue&type=script&lang=js"
export * from "./footerText.vue?vue&type=script&lang=js"
import style0 from "./footerText.vue?vue&type=style&index=0&id=2371391a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371391a",
  null
  
)

export default component.exports